import PropTypes from "prop-types";
import React from "react";
import { reportClientCrashToNimbble } from "utils/nimbble-alert";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    if (window.newrelic) {
      window.newrelic.noticeError(error, {
        componentStack: errorInfo?.componentStack,
        boundary: "AppErrorBoundary",
      });
    }

    reportClientCrashToNimbble({
      errorType: "render",
      error,
      componentStack: errorInfo?.componentStack,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="tw-flex tw-items-center tw-justify-center tw-min-h-screen tw-bg-gray-50">
          <div className="tw-text-center tw-p-8">
            <h2 className="tw-text-2xl tw-font-bold tw-text-gray-900 tw-mb-4">
              Something went wrong
            </h2>
            <p className="tw-text-gray-600 tw-mb-6">
              We&apos;re sorry, but something unexpected happened. Please try refreshing the page.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="tw-bg-blue-600 tw-text-white tw-px-6 tw-py-2 tw-rounded-md hover:tw-bg-blue-700 tw-transition-colors"
            >
              Refresh Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ErrorBoundary;